<template>
  <div id="organisation-team">
    <div class="content-wrapper">
      <div class="content animated fadeIn">
        <transition name="slide-fade">
          <div v-if="isFilterEnabled" class="card card-collapsed filter-card">
            <div class="card-header">
              <div class="card-title-container">
                <h5 class="card-title">{{ $t("organisation.team.authorize") }}</h5>
                <!-- <span>{{ $t("contentManagement.areaMap.filterMsg") }}</span> -->
              </div>
              <div class="header-elements">
                <el-button-group>
                  <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                    <el-button @click="$helpMe(null)" icon="fas fa-life-ring" size="mini" round></el-button>
                  </el-tooltip>
                  <el-button type="warning" icon="el-icon-close" size="mini" @click="isFilterEnabled = false" round> {{$t('event.buttons.close')}}</el-button>
                </el-button-group>
              </div>
            </div>

            <div class="card-body add-person-card">
              <div class="auth-attend">
                <i class="fa fa-info-circle"></i>
                <span v-html="$t('organisation.team.authorizeMsg')"></span>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <label style="display: block">{{ $t("organisation.team.authorizeEmail") }}</label>
                  <el-input v-model="email" clearable></el-input>
                  <span class="error">{{ $errorMessage("email", validationErrors) }}</span>
                </div>

                <div class="col-md-3" v-if="getEnums != null && getEnums != undefined">
                  <label style="display: block">{{ $t("organisation.team.authorizeGroup") }}</label>
                  <el-select v-if="teamContent" v-model="role" clearable filterable :placeholder="$t('organisation.team.placeholderAuthorityGroup')">
                    <el-option v-for="(type, index) in getEnums.find(x => x.title == 'TypeOfAuthority').enums.filter(x => x.key != 1)" :label="type.displayName" :value="type.key" :key="index + 'accesstype'"></el-option>
                  </el-select>
                  <span class="error">{{ $errorMessage("role", validationErrors) }}</span>
                </div>
                <div class="col-md-3">
                  <label style="display: block">{{ $t("organisation.team.authorizeEvent") }}</label>
                  <el-select v-if="teamContent" v-model="eventID" :disabled="role == 2" clearable filterable multiple collapse-tags :placeholder="$t('organisation.team.placeholderEvents')" @focus="validationErrors ? (validationErrors = []) : ''">
                    <el-option v-for="item in teamContent.events" :key="item.id" :label="item.title" :value="item.id" class="custom-option-event">
                      <el-avatar :size="'small'" :src="item.image != null ? $imageus + item.image + '?width=200&height=200' : ''"></el-avatar>
                      <span class="custom-option-title">{{ item.title }}</span>
                    </el-option>
                  </el-select>
                  <span class="error">{{ $errorMessage("eventIds", validationErrors) }}</span>
                </div>
                <div class="col-md-2">
                  <label style="display: block">&nbsp;</label>
                  <el-button class="add-member" @click="addUser" :loading="loading == 'addmember'">{{ $t("organisation.team.addMember") }}</el-button>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ $t("organisation.team.team") }}</h5>
              <span v-if="teamContent" v-html="$t('totalContent', [teamContent.users.length])"></span>
            </div>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('organisation.team.addMemberNew')" placement="top">
                  <el-button round type="primary" size="mini" class="create-event-button" icon="fas fa-plus" @click="isFilterEnabled = !isFilterEnabled">{{ $t("organisation.team.addMember") }}</el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button :icon="loading == 'loadingList' ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="refresh" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <div class="card-body team-card">
            <div class="custom-grid-table-header">
              <span>{{ $t("organisation.team.teamMember") }}</span>
              <span>{{ $t("organisation.team.authority") }}</span>
              <span>{{ $t("organisation.team.status") }}</span>
              <span></span>
            </div>
            <div class="custom-grid-team-list" v-if="teamContent && teamContent.users">
              <div class="item" v-for="member in teamContent.users" :key="member.id" :class="{ passive: !member.isActive }">
                <div class="area-1" @click="member.show = !member.show">
                  <div class="member-info">
                    <el-avatar size="small" :src="member.image != null ? $imageus + member.image + '?width=200&height=200' : ''"></el-avatar>
                    <span class="team-user-email d-flex flex-column" style="gap:4px">
                      <span>
                        {{ member.userDetail == null ? member.email : member.userDetail.email }}
                      </span>
                      <span v-if="!member.isRegistrationCompleted" class="d-block text-danger bold">{{ $t("organisation.team.waitingApproval") }}</span>
                    </span>
                  </div>
                  <div class="member-role">{{ getEnumsDisplay("TypeOfAuthority", member.role) }}</div>
                  <div @click.stop>
                    <el-switch @change="statusChanged($event, member.id)" v-model="member.isActive" v-if="member.role != 1"></el-switch>
                  </div>
                  <div class="actions" @click.stop>
                    <el-tooltip class="item" effect="dark" :content="$t('event.table.delete')" placement="top" v-if="member.role != 1">
                      <el-popconfirm @confirm="deleteItem(member.id)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                        <el-button slot="reference" type="danger" icon="fas fa-trash" circle size="mini"></el-button>
                      </el-popconfirm>
                    </el-tooltip>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="area-2" v-if="member.show">
                    <span v-if="member.role == 1">{{ $t("organisation.team.mainUserAuthorize") }}</span>
                    <span v-else-if="member.role == 2">{{ $t("organisation.team.coOwnerUserAuthorize") }}</span>

                    <div class="row" v-else>
                      <div class="col-md-5">
                        <label style="display: block">{{ $t("organisation.team.authorizeEvent") }}</label>
                        <el-select v-if="teamContent" v-model="member.eventIds" clearable filterable multiple collapse-tags :placeholder="$t('organisation.team.placeholderEvents')" @focus="validationErrors ? (validationErrors = []) : ''">
                          <el-option v-for="item in teamContent.events" :key="item.id" :label="item.title" :value="item.id" class="custom-option-event">
                            <el-avatar :size="'small'" :src="item.image != null ? $imageus + item.image + '?width=200&height=200' : ''"></el-avatar>
                            <span class="custom-option-title">{{ item.title }}</span>
                          </el-option>
                        </el-select>
                        <span class="error">{{ $errorMessage("eventID", validationErrors) }}</span>
                      </div>
                      <div class="col-md-5">
                        <label style="display: block">{{ $t("organisation.team.authorizeGroup") }}</label>
                        <el-select v-model="member.role" clearable filterable placeholder="Select authority group">
                          <el-option v-for="(type, index) in getEnums.find(x => x.title == 'TypeOfAuthority').enums.filter(x => x.key != 1)" :label="type.displayName" :value="type.key" :key="index + 'accesstype'"></el-option>
                        </el-select>
                        <span class="error">{{ $errorMessage("roleGroupID", validationErrors) }}</span>
                      </div>
                      <div class="col-md-2">
                        <label style="display: block">&nbsp;</label>
                        <el-button type="primary" @click="update(member)" :loading="loadingUpdate == member.id">{{ $t("organisation.team.update") }}</el-button>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </div>

          <div class="card-footer"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import PageCountInfo from "@/components/PageCountInfo";
import RoleGroupAddUpdate from "@/components/RoleGroupAddUpdate";

export default {
  components: { PageCountInfo, RoleGroupAddUpdate },
  name: "OrganisationTeam",
 metaInfo() {
    return {
      title: this.$t("eventPageTitle.organisationTeam")
    };
  },

  data() {
    return {
      setFormId: null,
      modalVisible: false,
      isFilterEnabled: false,
      updateForm: null,
      timeout: null,
      email: null,
      role: null,
      eventID: null,
      filterEventID: null,
      filterGroupID: null,
      form: {},
      options: [],
      value: [],
      list: [],
      loading: false,
      loadingUpdate: false,
      states: ["ozkan@internative.net", "kemal@internative.net", "begum@internative.net", "heskikoy@internative.net", "ykankaya@internative.net", "seskikoy@internative.net"]
    };
  },

  async created() {
    await this.$store.dispatch("getOrganizationTeamContent");
    await this.$store.dispatch("getLoadAllRoles");
  },
  mounted() {
    this.list = this.states.map(item => {
      return { value: item, label: item };
    });
  },

  methods: {
    refresh() {
      this.loading = "loadingList";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
       await this.$store.dispatch("getOrganizationTeamContent");
       await this.$store.dispatch("getLoadAllRoles");
       this.loading = false;
      }, 500);
    },
    toogleExpand(row) {
      let $table = this.$refs.multipleTable;
      $table.toggleRowExpansion(row);
    },

    // reSend(item) {
    //   axios
    //     .post("Organization/resendinvitation", {
    //       id: item.id,
    //     })
    //     .then((res) => {
    //       this.$store.dispatch("getUsers")

    //       if (res.data.alert.hasError) {
    //         this.$message.error(res.data.alert.message)
    //       } else {
    //         this.$message.success(res.data.alert.message)
    //       }
    //     })
    // },
    handleSelectionChange(items) {
      this.$store.commit("setUsersTake", items);
    },
    handleSizeChange(take) {
      this.$store.commit("setUsersTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setUsersPage", page);
    },
    itemUpdated(item) {
      this.$store.dispatch("getUsers");
    },
    itemAdded(item) {
      this.$store.dispatch("getUsers");
    },
    async deleteItem(index) {
      await this.$store.dispatch("deleteMemberFromTeam", index);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    },
    async statusChanged(value, id) {
      await this.$store.dispatch("toggleMemberIsActive", id);
    },
    async update(item) {
      this.loadingUpdate = item.id;
      var payload = {
        email: item.email,
        role: item.role,
        eventIds: item.eventIds
      };
      await this.$store.dispatch("addUpdateTeamMember", payload);
      await this.$store.dispatch("getOrganizationTeamContent");

      this.loadingUpdate = false;
    },
    async addUser() {
      this.loading = "addmember";
      var payload = {
        email: this.email,
        role: this.role,
        isAdd: true,
        eventIds: this.eventID
      };
      var res = await this.$store.dispatch("addUpdateTeamMember", payload);
      if (!res.data.alert.hasError) {
        this.email = null;
        this.eventID = null;
        this.role = null;
      }
      this.loading = false;
    }
  },
  watch: {
    role() {
      if (this.role == 2) {
        this.eventID = [...this.teamContent.events.map(event => event.id)];
      } else {
        this.eventID = [];
      }
    }
  },
  computed: {
    getEnums() {
      return this.$store.getters.getEnums;
    },
    validationErrors() {
      return this.$store.getters.getOrganizationValidationErrors;
    },
    teamContent() {
      return this.$store.getters.getOrganizationTeamContent;
    },
    getAllRoles() {
      return this.$store.getters.getLoadAllRoles;
    }
  }
};
</script>

<style lang="less">
.custom-option-event {
  padding: 4px 8px;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  span {
    &.custom-option-title {
      margin-left: 8px;
      color: #505763;
      font-size: 14px;
      font-weight: 400;
    }

    img {
      border: 0.5px solid #dcdfe6;
      border-radius: 50%;
      background: white;
    }
  }
}

#organisation-team {
  width: 100%;

  .card-body {
    .custom-grid-table-header {
      grid-template-columns: 1fr 140px 50px 40px !important;
    }
    .custom-grid-team-list {
      display: flex;
      flex-direction: column;
      & > .item {
        transition: all 0.5s;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        background-color: #f1f1f1;
        margin-bottom: 8px;

        &:last-child {
          margin-bottom: unset;
        }
        &.passive {
          background-color: #fff2f2 !important;
        }
        .area-1 {
          cursor: pointer;
          .member-info {
            display: flex;
            gap: 10px;
            align-items: center;
            font-size: 14px;
            color: #8c929c;
          }
          .actions {
            display: flex;
            justify-content: flex-end;
          }
          .member-role {
            font-weight: 500;
            text-decoration: underline;
          }
          i.burger {
            box-sizing: border-box;
            font-size: 20px;
            color: #505763;
            &.me {
              color: #ccc;
            }
          }
          .venue-title {
            display: flex;
            flex-direction: column;
            color: #292f3b;
            font-weight: 600;
            span {
              font-weight: 500;
              color: #505763;
            }
          }

          .action-btns {
            gap: 4px;
            button {
              &:nth-child(2) {
                margin-left: unset !important;
              }
            }
          }

          padding: 10px;
          display: grid;
          grid-template-columns: 1fr 140px 50px 40px;
          gap: 0.5rem;
          align-items: center;
          .btn-area {
            display: flex;
            justify-content: flex-end;
            align-items: center;
          }
        }
        .area-2 {
          padding: 10px;
        }
      }
    }
    &.add-person-card {
      .auth-attend {
        width: 100%;
        padding: 14px 16px;
        background: #268ea621;
        border-radius: 8px;
        margin: 16px 0px;

        i {
          color: #268ea6;
          font-size: 18px;
          margin-right: 8px;
        }

        span {
          font-size: 14px;
        }
      }
      .add-member {
        background-color: #268ea6;
        color: white;
        border-color: #268ea6;
        width: 100%;
      }
    }
  }

  .team-card {
    .el-table__header-wrapper {
      display: none;
    }

    .team-user-title {
      font-size: 16px;
      color: #505763;
      display: block;

      b {
        color: #292f3b;
      }
    }

    .team-user-email {
      font-size: 14px;
      color: #8c929c;
      display: block;
    }

    .team-auth-title {
      font-size: 14px;
      color: #8c929c;

      i {
        font-size: 12px;
        margin-right: 3px;
      }
    }

    .actions {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: 0.2rem;
      button {
        aspect-ratio: 1;
        i {
          margin: 0;
          padding: 0;
        }
      }
    }
  }

  &.add-group-card {
    .card-header {
      .header-elements {
        .add-button {
          background-color: #268ea6;
          color: white;
          border-color: #268ea6;
        }
      }
    }

    .card-body {
      .auth-card {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
        margin: 14px 0px;

        &:first-child {
          margin-top: 30px;
        }

        .auth-icon {
          width: 40px;
          height: 40px;
          display: inline-flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          border-radius: 50%;

          i {
            color: white;
            line-height: 18px;
            font-size: 16px;
            padding: 1px;
          }
        }

        .auth-title {
          display: inline-flex;
          align-items: flex-start;
          justify-content: center;
          flex: 1;
          flex-direction: column;
          padding-left: 14px;

          p {
            color: #292f3b;
            font-weight: 500;
            font-size: 16px;
            padding: 0px;
            margin: 0px;
          }

          span {
            color: #8c929c;
          }
        }

        .auth-proc {
          display: block;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/OrganisationTeam.vue